import attemptResultProcessing from "../../../../../../public/images/access-screens/attemptResultProcessing.png";
import { useTranslation } from "react-i18next";

const AttemptResultProcessing = ({
  orgBasedFeatureName = "assessment"
}: {
  orgBasedFeatureName: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center py-5 w-full  space-y-5 text-center">
      <img
        src={attemptResultProcessing}
        alt={t("assessment.accessScreens.attemptResultProcessing.alt", {
          featureName: orgBasedFeatureName
        })}
        className="w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] object-cover"
      />
      <div className="max-w-[800px]">
        <h1 className="text-2xl text-primary font-bold">
          {t("assessment.accessScreens.attemptResultProcessing.title")}
        </h1>
        <p className="mt-5 text-primary text-base">
          {t("assessment.accessScreens.attemptResultProcessing.description", {
            featureName: orgBasedFeatureName
          })}
        </p>
      </div>
    </div>
  );
};

export default AttemptResultProcessing;
